import { defineComponent as _defineComponent } from 'vue'
import AlertBanner from '@/components/AlertBanner.vue';
import { computed } from 'vue';
import ProvVis from '@/components/ProvVis.vue';
import ControlPanel from '@/components/ControlPanel.vue';
import MultiMatrix from '@/components/MultiMatrix.vue';
import EdgeSlices from '@/components/EdgeSlices.vue';
import { getUrlVars } from '@/lib/utils';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const urlVars = getUrlVars();

store.dispatch.fetchNetwork({
  workspaceName: urlVars.workspace,
  networkName: urlVars.network,
}).then(() => {
  store.dispatch.createProvenance();
});
const network = computed(() => store.state.network);

const loadError = computed(() => store.state.loadError);

const showProvenanceVis = computed(() => store.state.showProvenanceVis);

const slicedNetwork = computed(() => store.state.slicedNetwork.length > 1);


return { __sfc: true,urlVars, network, loadError, showProvenanceVis, slicedNetwork, AlertBanner, ProvVis, ControlPanel, MultiMatrix, EdgeSlices }
}

})